export const getCount = (names: string[]): Record<string, number> => {
  return names.reduce(
    (acc, name) => {
      if (!acc[name]) {
        acc[name] = 0
      }
      acc[name]++
      return acc
    },
    {} as Record<string, number>,
  )
}

export const sortDictionaryByCount = (
  dictionary: Record<string, number>,
): [string, number][] => {
  // Create items array
  var items = Object.keys(dictionary).map(function (key) {
    return [key, dictionary[key]!] as [string, number]
  })

  // Sort the array based on the second element
  return items.sort(function (first, second) {
    return second[1] - first[1]
  })
}
